<template>
  <div
    :class="bem()"
  >
    <div
      :class="bem('image')"
      :style="`aspect-ratio: ${aspectRatio}`"
    >
      <DatoCmsImage
        :data="props.item.inlineImage.responsiveImage"
        object-fit="cover"
        :object-position="`${props.item.inlineImage.focalPoint.x * 100}% ${
          props.item.inlineImage.focalPoint.y * 100
        }%`"
        layout="fill"
        sizes="(max-width: 1280px) 100vw, 40vw"
      />
    </div>
    <div :class="bem('main')">
      <VisionHeading
        tag="h6"
        size="h4"
        :class="bem('quote')"
      >
        {{ props.item.quote }}
      </VisionHeading>
      <p
        v-if="props.item.secondary"
        :class="bem('secondary')"
      >
        {{ props.item.secondary }}
      </p>
      <div :class="bem('details')">
        <p
          v-if="props.item.name"
          :class="bem('detail-text')"
        >
          {{ props.item.name }}
        </p>
        <span
          v-if="props.item.subtitle"
          :class="bem('detail-text', {'grey':true})"
        >
          {{ props.item.subtitle }}
        </span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { Image as DatoCmsImage } from 'vue-datocms'

const bem = useBEM('CredibilityImage')

const props = defineProps({
  item: { type: Object, required: true }
})

const aspectRatio = computed(() => {
  let ratio = props.item.aspectRatio
  // Reformat incorrect aspect ratios for this type
  if (ratio === '9/16' || ratio === '4/5') ratio = '1/1'
  return ratio
})
</script>

<style lang="postcss">
.CredibilityImage {
  @apply flex flex-col gap-6
  justify-between items-stretch
  py-2 px-2 pb-6 rounded-lg
  bg-grey-200;
}

.CredibilityImage__main {
  @apply flex flex-col gap-4 px-3;
}

.CredibilityImage__image {
  @apply rounded-lg overflow-clip w-full flex relative;
}

.CredibilityImage__details {
  @apply flex justify-between items-center;
}

.CredibilityImage__detail-text {
  @apply text-xs;

  &--grey {
    @apply text-mid-grey;
  }
}
</style>